export function sendWindowsContentHeight() {
  window.parent.postMessage(
    JSON.stringify({
      event: "resize",
      height: $(document).height(),
    }),
    "*"
  );
}



// WEBPACK FOOTER //
// ./src/newDesign/utils/sendWindowsContentHeight.js